import { useAtdThemeContext } from "~/v3-poc/features/user-preferences";
import { PortfolioHistoryChart } from "./PortfolioHistoryChart.connector";

export interface PortfolioHistoryWidgetProps {
  id: string;
}

export const PortfolioHistoryWidget = ({ id }: PortfolioHistoryWidgetProps) => {
  const { theme } = useAtdThemeContext();

  return <PortfolioHistoryChart id={id} theme={theme} />;
};
